/**
 * Internal depedencies
 */
import { saveEditedLayout } from 'state/dashboard-layouts/actions';
import { getLayoutId } from 'state/dashboard/selectors';

export default () => (dispatch, getState) => {
	const layoutId = getLayoutId(getState());
	return dispatch(saveEditedLayout(layoutId));
};
